import { lazyLoad } from '../../../shared/utils/loadable';

export const UserPaymentHistoryPage = lazyLoad(
  () => import('./index'),
  (module) => module.UserPaymentHistory,
);
